/* hs-eslint ignored failing-rules */
/* eslint-disable hubspot-dev/no-unnamed-components */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useTrellisSmileys"];
import { isCanvasTheme, useTheme } from 'foundations-theming/utils';
import CsatButton from './internal/CsatButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TRELLIS_SMILEYS_POSITIVE_COLOR, resolveRespondentCssColor } from 'feedback-schema/constants/respondentTypeColorTokens';
import * as RespondentTypes from 'feedback-schema/constants/respondentTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default (_ref => {
  let {
      useTrellisSmileys = false
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const trellisTheme = useTheme();
  return isCanvasTheme(trellisTheme) ? /*#__PURE__*/_jsx(CsatButton, Object.assign({
    color: trellisTheme.color['do-not-use-chart-green'],
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.positive"
    }),
    viewBox: "0 0 54 54"
  }, props, {
    children: /*#__PURE__*/_jsx("g", {
      id: "Setup---Choose-Survey---CSAT---Chat",
      transform: "translate(-1037.000000, -762.000000)",
      fillRule: "nonzero",
      children: /*#__PURE__*/_jsx("g", {
        id: "chat-widget",
        transform: "translate(761.000000, 320.000000)",
        children: /*#__PURE__*/_jsxs("g", {
          id: "Happy",
          transform: "translate(277.000000, 443.000000)",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M26,0 C11.6405965,0 0,11.6405965 0,26 C0,40.3594035 11.6405965,52 26,52 C40.3594035,52 52,40.3594035 52,26 C51.9787869,11.6493924 40.3506076,0.0212130541 26,0 Z",
            id: "Path",
            stroke: "#33475C",
            strokeWidth: "2",
            fill: "#A5DA98"
          }), /*#__PURE__*/_jsx("path", {
            d: "M35.0518519,18.1422222 C36.5085151,18.1422222 37.821746,19.019695 38.3791869,20.3654764 C38.9366278,21.7112578 38.6285003,23.2603192 37.5984838,24.2903357 C36.5684673,25.3203522 35.019406,25.6284796 33.6736246,25.0710387 C32.3278432,24.5135978 31.4503704,23.200367 31.4503704,21.7437037 C31.4503704,19.7546604 33.0628086,18.1422222 35.0518519,18.1422222 L35.0518519,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M16.9481481,18.1422222 C18.4048114,18.1422222 19.7180423,19.019695 20.2754832,20.3654764 C20.8329241,21.7112578 20.5247966,23.2603192 19.4947801,24.2903357 C18.4647636,25.3203522 16.9157022,25.6284796 15.5699209,25.0710387 C14.2241395,24.5135978 13.3466667,23.200367 13.3466667,21.7437037 C13.3466667,19.7546604 14.9591048,18.1422222 16.9481481,18.1422222 Z",
            id: "Path",
            fill: "#33475C"
          }), /*#__PURE__*/_jsx("path", {
            d: "M38.922963,35.8992593 C35.2593261,38.8744361 30.7175935,40.5598182 26,40.6948148 C21.2879446,40.5613348 16.7518509,38.8755328 13.0962963,35.8992593 C12.4049176,35.2982916 12.331625,34.250638 12.9325926,33.5592593 C13.5335603,32.8678806 14.5812139,32.794588 15.2725926,33.3955556 C18.3301006,35.837351 22.0898935,37.2346169 26,37.3822222 C29.9178391,37.2441319 33.686646,35.8460261 36.7466667,33.3955556 C37.1939103,33.0067976 37.8145803,32.8861721 38.3748763,33.0791175 C38.9351723,33.2720629 39.349972,33.7492661 39.4630244,34.3309694 C39.5760769,34.9126726 39.3702066,35.5105014 38.922963,35.8992593 L38.922963,35.8992593 Z",
            id: "Path",
            fill: "#33475C"
          })]
        })
      })
    })
  })) : /*#__PURE__*/_jsxs(CsatButton, Object.assign({
    color: resolveRespondentCssColor(RespondentTypes.PROMOTER, useTrellisSmileys, trellisTheme),
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "feedback-shared.ratings.positive"
    }),
    viewBox: "0 0 80 80"
  }, props, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_604_1078)",
      children: [/*#__PURE__*/_jsx("rect", {
        width: "80",
        height: "80",
        rx: "40",
        fill: useTrellisSmileys ? TRELLIS_SMILEYS_POSITIVE_COLOR : '#97DBAE'
      }), /*#__PURE__*/_jsx("path", {
        d: "M52.8887 39.5556C55.9969 39.5556 58.5183 37.0342 58.5183 33.926C58.5183 30.8179 55.9969 28.2964 52.8887 28.2964C49.7806 28.2964 47.2591 30.8179 47.2591 33.926C47.2591 37.0342 49.7806 39.5556 52.8887 39.5556Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M32.7406 33.8668C32.7406 30.7586 30.2191 28.2371 27.1109 28.2371C24.0028 28.2371 21.4813 30.7586 21.4813 33.8668C21.4813 36.9749 24.0028 39.4964 27.1109 39.4964C30.2191 39.4964 32.7406 36.9749 32.7406 33.8668Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        d: "M40.0443 61.5112C47.742 61.3068 54.7969 58.5364 60.3257 54.0742L60.3287 54.0712C60.8976 53.5616 61.2561 52.8208 61.2561 51.9971C61.2561 51.3067 61.0043 50.6756 60.5924 50.1927L60.5894 50.1897C60.0857 49.6238 59.348 49.2653 58.5302 49.2653C57.8457 49.2653 57.2176 49.5142 56.7406 49.926L56.7998 49.8816C52.1657 53.5675 46.3731 55.8579 39.9998 56.1186L39.9406 56.1156C33.6294 55.8401 27.8546 53.5053 23.3183 49.8075L23.3213 49.8105C22.8383 49.3868 22.2043 49.1319 21.5109 49.1319C20.6843 49.1319 19.9435 49.4964 19.4369 50.0742L19.4398 50.0712C19.025 50.5571 18.7731 51.1882 18.7731 51.8786C18.7731 52.7023 19.1317 53.4431 19.7035 53.9556L19.6443 53.9082C25.2087 58.4623 32.2546 61.2742 39.9998 61.5112H40.0443Z",
        fill: "#141414"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 40C0 62.0919 17.9081 80 40 80H40.003C62.0859 79.9822 79.9822 62.0859 80 40C80 17.9081 62.0919 0 40 0C17.9081 0 0 17.9081 0 40ZM5.71852 40C5.71852 21.0667 21.0667 5.71852 40 5.71852H40.003C58.9274 5.7363 74.2637 21.0726 74.2815 40C74.2815 58.9333 58.9333 74.2815 40 74.2815C21.0667 74.2815 5.71852 58.9333 5.71852 40Z",
        fill: "#141414"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_604_1078",
        children: /*#__PURE__*/_jsx("rect", {
          width: "80",
          height: "80",
          rx: "40",
          fill: "white"
        })
      })
    })]
  }));
});